<template>
    <section id="photo-slider">
        <div class="image">
            <img :src="thumbnailPath" v-on:click="changeFullScreen">
        </div>
        <transition name="photo-slider">
            <div v-if="fullscreenFlag"
                class="fullscreen-controller"
                v-cloak>
                <div
                    class="slider-touch-frame"
                    @touchstart="OnTouchStart($event)"
                    @touchmove="OnTouchMove($event)"
                    @touchend="OnTouchEnd()"
                >
                    <div class="image-frame">
                        <div class="vue-slider-box fullscreen-content">
                            <div class="vue-slider-main">
                                <div class="vue-slider-content-box">
                                    <transition v-bind:name="transitionName">
                                        <div class="vue-slider-content" v-for="(item, index) in contents" v-if="visibleContent == index" v-bind:key="index">
                                            <img v-bind:src="item.path" v-bind:alt="item.title">
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition name="slider-menu">
                        <div class="slider-menu" v-show="0 < buttonShowFlag">
                            <div class="menu-top">
                                <div class="top-center" v-for="(item, index) in contents" v-if="visibleContent == index" v-bind:key="index">
                                    <!-- <p class="image-title">{{ item.title }}</p> -->
                                </div>
                                <div class="top-right">
                                    <button type="button" class="close-button" v-on:click="changeFullScreen">&times;</button>
                                </div>
                            </div>
                            <div class="vue-slider-box fullscreen-content">
                                <a href="javascript:void(0);" class="vue-slider-prev-btn" v-on:click="sliderPrev"><i></i></a>
                                <a href="javascript:void(0);" class="vue-slider-next-btn" v-on:click="sliderNext"><i></i></a>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="vue-slider-thumbnail-box">
                    <ul class="vue-slider-thumbnail-list">
                        <li class="vue-slider-thumbnail" :class="visibleContent == index ? 'selected-thumbnail' : 'unselected-thumbnail'"
                             v-for="(item, index) in contents" v-bind:key="index" v-on:click="sliderJump(index)">
                            <img v-bind:src="item.path">
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </section>
</template>

<script>
    export default {
        name: "photo-slider",
        props: ['item_id', 'kind'],
        data: function () {
            return {
                contents: Array,
                visibleContent: 0,
                transitionName: '',
                fullscreenFlag: false,
                buttonShowFlag: 0,
                supportTouch: undefined,
                thumbnailPath: '',
                swipe: {
                    flag: false,
                    threshold: 60,
                    start: {
                        x: 0
                    },
                    current: {
                        x: 0
                    },
                    distance: {
                        x: 0
                    },
                },
                sessionStorageTitles: null,  // null で初期化
            }
        },
        mounted() {
            // ローカルストレージからサムネイルの画像データを取得
            let minZValue = Infinity;
            let minZKey = '';
            let storedThumbnail;
            
            // ローカルストレージから全ての画像データを取得
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                // 'contents_image_'で始まるキーだけを対象にする
                if (key && key.startsWith('contents_image_')) {
                    // contents_image_を空に置き換え、残ったものを10進法で残す
                    const zValue = parseInt(key.replace('contents_image_', ''), 10);
                    
                    // zの値が現在の最小値より小さい場合、更新
                    if (!isNaN(zValue) && zValue < minZValue) {
                        // Not a Number = NaN
                        minZValue = zValue;
                        minZKey = key;
                    }
                }
            }
            // 最もzの値が小さい画像が存在する場合、表示
            if (minZKey !== '') {
                storedThumbnail = localStorage.getItem(minZKey);
            } 
            
            // let storedAlbumData;
            const storedAlbumData = Object.keys(localStorage)
            .filter(key => key.startsWith('contents_image'))
            .map(key => {
                return {
                    path: localStorage.getItem(key),
                };
            });

            this.thumbnailPath = storedThumbnail;

            if (storedAlbumData.length > 0) {
                this.contents = storedAlbumData;
            } 


            this.supportTouch = 'ontouchend' in document;
            axios.default
                .get('/photo/'+this.kind+'/get/'+this.item_id)
                .then(response => {
                    
                const storedSessionStorageTitles = JSON.parse(sessionStorage.getItem('musicTitles')) || [];
                this.sessionStorageTitles = storedSessionStorageTitles.map(title => title || '');  // 空文字に変更
                });
        },
        methods: {
            // スライダーを戻す処理
            sliderPrev() {
                this.transitionName = 'show-prev';
                if(this.visibleContent === 0) {
                    this.visibleContent = this.contents.length - 1;
                } else {
                    this.visibleContent--;
                }
                this.showSliderButton();
            },
            // スライダーを進める処理
            sliderNext() {
                this.transitionName = 'show-next';
                if(this.visibleContent === this.contents.length - 1) {
                    this.visibleContent = 0;
                } else {
                    this.visibleContent++;
                }
                this.showSliderButton();
            },
            sliderJump(index) {
                this.visibleContent = index;
            },
            // フルスクリーンにする
            changeFullScreen() {
                if(this.contents.length == 0) {
                    return;
                }
                if(this.fullscreenFlag) {
                    this.fullscreenFlag = false;
                    document.removeEventListener(this.supportTouch ? 'touchend' : 'mousemove', this.showSliderButton, false);
                } else {
                    this.fullscreenFlag = true;
                    document.addEventListener(this.supportTouch ? 'touchend' : 'mousemove', this.showSliderButton, false);
                }
            },
            // 「進む」「戻る」ボタンを3秒間表示し続ける
            showSliderButton: function() {
                this.buttonShowFlag++;
                setTimeout(function() {
                    this.buttonShowFlag--;
                }.bind(this), 3000);
            },
            OnTouchStart: function(event) {
                if(event.touches.length != 1) {
                    return;
                }
                this.swipe.flag = true;
                this.swipe.start.x = event.touches[0].pageX;
            },
            OnTouchMove: function(event) {
                if(event.touches.length != 1) {
                    return;
                }
                this.swipe.current.x = event.touches[0].pageX;
                this.swipe.distance.x = this.swipe.current.x - this.swipe.start.x;
            },
            OnTouchEnd: function() {
                if( this.swipe.flag && this.swipe.distance.x > 0 && this.swipe.distance.x >= this.swipe.threshold){
                    // 右スワイプ後の処理を記述
                    this.sliderPrev();
                }
                if( this.swipe.flag && this.swipe.distance.x < 0 && this.swipe.distance.x * -1 >= this.swipe.threshold){
                    // 左スワイプ後の処理を記述
                    this.sliderNext();
                }
                this.swipe.start.x = 0;
                this.swipe.current.x = 0;
                this.swipe.distance.x = 0;
                this.swipe.flag = false;
            },
        },
    }
</script>

<style scoped>
[v-cloak] {
display: none;
}
</style>
